export const authorizationRequest = "AUTH_REQUEST";
export const authorizationSuccess = "AUTH_SUCCESS";
export const authorizationFail = "AUTH_FAILUE";
